import IconFont from '@/components/IconFont.vue';
import TitleChunk from '@/components/TitleChunk.vue';
import Specialists from '@/components/Specialists.vue';
import ListPlaceholder from '@/components/SearchBox/SearchPlaceholder.vue';
import BottomTab from '@/components/BottomTab.vue';
import BorderLine from '@/components/BorderLine/index.vue';

export default {
  IconFont,
  TitleChunk,
  Specialists,
  ListPlaceholder,
  BottomTab,
  BorderLine
};
